import "./Contact.css";
import { useRef } from "react";
import emailjs from "@emailjs/browser";

export default function Contact() {

  const form = useRef();

  const sendEmail = (e) => {

    e.preventDefault();

    emailjs.sendForm(
      "website2408",
      "template_3jw18iq",
      form.current,
      "Lp1ynhDawfQAFKJZ6"
    )

    .then(() => {

      alert("Mesaj başarıyla gönderildi!");

      form.current.reset();

    })

    .catch((error) => {

      alert("Bir hata oluştu.");
      console.log(error);

    });

  };

  return (

    <section className="contact-page">

      <div className="contact-header">

        <span>İLETİŞİM</span>

        <h1>Bize Ulaşın</h1>

        <p>
          Ücretsiz keşif ve fiyat teklifi için formu doldurun.
          Uzman ekibimiz en kısa sürede sizinle iletişime geçecek.
        </p>

      </div>

      <div className="contact-container">

        {/* LEFT */}

        <div className="contact-info">

          <div className="info-box">
            <h3>Telefon</h3>
            <p>Batuhan YAYLA</p>
            <p>+90 536 984 81 73</p>
          </div>

          <div className="info-box">
            <h3>Email</h3>
            <p>batuhanyayyla28@gmail.com</p>
          </div>

          <div className="info-box">
            <h3>Adres</h3>
            <p>Giresun / Tirebolu</p>
          </div>

          <div className="info-box">
            <h3>Çalışma Saatleri</h3>
            <p>Pazartesi - Cumartesi</p>
            <p>08:00 - 19:00</p>
          </div>

        </div>

        {/* RIGHT */}

        <form
          ref={form}
          onSubmit={sendEmail}
          className="contact-form"
        >

          <input
            type="text"
            name="name"
            placeholder="Ad Soyad"
            required
          />

          <input
            type="email"
            name="email"
            placeholder="E-posta"
            required
          />

          <input
            type="text"
            name="phone"
            placeholder="Telefon"
          />

          <textarea
            name="message"
            placeholder="Mesajınız"
            required
          ></textarea>

          <button type="submit">
            Gönder
          </button>

        </form>

      </div>

    </section>
  );
}